import { useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/pt-br'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateView } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { DatePickerContainer } from './DatePickerWrapper.styles'

dayjs.locale('pt-br')

const pickerColor = '#01c38d'

const textFieldSx = {
  minWidth: 120,
  maxWidth: 140,
  '& .MuiInputBase-root': {
    height: 32,
    fontSize: '12px',
  },
  '& input': {
    paddingLeft: '4px',
  },
}

const popperSx = {
  '& .MuiPaper-root': {
    border: '1px solid #ddd',
    borderRadius: '4px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  '& .MuiPickersCalendarHeader-root': {
    backgroundColor: pickerColor,
    color: '#fff',
  },
  '& .MuiPickersCalendarHeader-label, & .MuiPickersArrowSwitcher-root button': {
    color: '#fff',
  },
  '& .MuiPickersDay-root.Mui-selected': {
    backgroundColor: `${pickerColor} !important`,
  },
}

interface DatePickerWrapperProps {
  selected: Date | null
  onChange: (date: Date | null) => void
  placeholder?: string
}

export function DatePickerWrapper({ selected, onChange, placeholder }: DatePickerWrapperProps) {
  const [view, setView] = useState<DateView>('day')

  const handleChange = (date: Dayjs | null) => onChange(date?.toDate() ?? null)

  return (
    <DatePickerContainer>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
        <DatePicker
          value={selected ? dayjs(selected) : null}
          onChange={handleChange}
          views={['year', 'month', 'day']}
          view={view}
          onViewChange={setView}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              placeholder,
              fullWidth: true,
              sx: textFieldSx,
            },
            openPickerButton: {
              sx: {
                color: pickerColor,
                width: 25,
                '& svg': {
                  fontSize: 25,
                  mr: 3,
                },
              },
            },
            popper: {
              sx: popperSx,
            },
          }}
        />
      </LocalizationProvider>
    </DatePickerContainer>
  )
}
